export default __webpack_public_path__ + "static/media/pdf-icon-white.c3a95771.svg";